module.exports = __webpack_public_path__ + "media/four-and-a-half-stars.b9483b2f.svg";